





















































import Vue from "vue";
import Tabs from "@/components/ui/Tabs.vue";
import RaumbezugTab from "@/components/tabs/massnahmen/RaumbezugTab.vue";
import StammdatenTab from "@/components/tabs/massnahmen/StammdatenTab.vue";
import DatenTab from "@/components/tabs/massnahmen/DatenTab.vue";
import SaveDialog from "@/components/dialog/SaveDialog.vue";
import { MetaInfo } from "vue-meta";
import { Massnahme } from "@/types/Massnahme";
import { massnahmenServiceInstance } from "@/services/MassnahmenService";
import { alertError } from "@/services/ErrorAlert";
import AlertService from "@/services/libs/AlertService";
import { RequestError } from "@/services/AuthService";
import PubSub from "pubsub-js";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";

export default Vue.extend({
  name: "MassnahmenDetail",
  components: {
    Tabs,
    RaumbezugTab,
    StammdatenTab,
    DatenTab,
    SaveDialog,
    DeleteDialog,
  },
  metaInfo(): MetaInfo {
    return {
      title: this.name,
    };
  },
  props: {
    /** passed via router through uri parameter */
    id: {
      type: [String, Number],
      required: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      massnahemkey: 0,
      massnahme: {} as Massnahme,
      openSaveDialog: false,
      openDeleteDialog: false,
    };
  },
  computed: {
    name(): string {
      return this.massnahme?.bezeichnung || "Maßnahme";
    },
  },
  mounted() {
    PubSub.subscribe("recieveCoordinate", this.onRecieveCoordinate);
    if (!(this.id === undefined || this.id === "undefined")) {
      this.isLoading = true;
      Promise.all([
        massnahmenServiceInstance
          .getMassnahme(this.id)
          .then((data: Massnahme) => (this.massnahme = data)),
      ])
        .catch((error: any) => alertError(error))
        .finally(() => (this.isLoading = false));
    }
  },
  methods: {
    onRecieveCoordinate(e: string, data: any) {
      this.massnahme.xKoordinate = data[0];
      this.massnahme.yKoordinate = data[1];
    },

    onDeleteConfirm() {
      this.isLoading = true;
      massnahmenServiceInstance
        .deleteMassnahme(this.id)
        .then(() => {
          // redirect
          this.$router.push({ name: "MassnahmenMain" });
          AlertService.info("Maßnahme gelöscht!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Löschen der Maßnahme ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => (this.isLoading = false));
    },

    onSaveConfirm() {
      if (!(this.id === undefined || this.id === "undefined")) {
        this.isLoading = true;
        massnahmenServiceInstance
          .updateMassnahme(this.id, this.massnahme)
          .then((data: Massnahme) => {
            this.massnahme = data;
            this.massnahemkey++;
            AlertService.info("Maßnahme gespeichert!");
          })
          .catch((error: RequestError) =>
            AlertService.error(
              "Beim Speichern der Maßnahme ist ein Fehler aufgetreten!",
              "Bitte versuchen Sie es in einiger Zeit erneut!",
              "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
              "Fehlermeldung: " + error.message,
            ),
          )
          .finally(() => (this.isLoading = false));
      } else {
        this.isLoading = true;
        massnahmenServiceInstance
          .createMassnahme(this.massnahme)
          .then((data: any) => {
            this.massnahme = data;
            this.massnahemkey++;
            this.$router.push({
              name: "MassnahmenDetail",
              params: { id: data.id },
              query: { editMode: "false" },
            });
            AlertService.info("Maßnahme gespeichert!");
          })
          .catch((error: RequestError) =>
            AlertService.error(
              "Beim Speichern der Maßnahme ist ein Fehler aufgetreten!",
              "Bitte versuchen Sie es in einiger Zeit erneut!",
              "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
              "Fehlermeldung: " + error.message,
            ),
          )
          .finally(() => (this.isLoading = false));
      }
    },
  },
});
